module.exports = __webpack_public_path__ + "img/image_21.aed090ed.png";